import { render } from "./ShippingExpertsSection.vue?vue&type=template&id=6d698771"
const script = {}

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__